import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fileEndings } from './file-endings.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i3 from "../../../basic-features/icon-v2/icon.component";
import * as i4 from "ngx-skeleton-loader";
import * as i5 from "primeng/tooltip";
const _c0 = a0 => ({
  "with-delete-icon ": a0
});
const _c1 = () => ({
  height: "32px",
  width: "100%",
  marginTop: "8px"
});
function FileRowComponent_section_0_geaui_icon_v2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isFileIcon", true)("color", "white")("file", "24px_" + ctx_r1.checkFileEnding(ctx_r1.fileEnding));
  }
}
function FileRowComponent_section_0_geaui_icon_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 10);
  }
}
function FileRowComponent_section_0_geaui_icon_v2_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 11);
    i0.ɵɵlistener("click", function FileRowComponent_section_0_geaui_icon_v2_7_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeFileByIndex.emit(ctx_r1.index));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("color", "black")("file", "16px_remove");
  }
}
function FileRowComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 3)(1, "div", 4);
    i0.ɵɵlistener("click", function FileRowComponent_section_0_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDownloadFile());
    });
    i0.ɵɵtemplate(2, FileRowComponent_section_0_geaui_icon_v2_2_Template, 1, 3, "geaui-icon-v2", 5)(3, FileRowComponent_section_0_geaui_icon_v2_3_Template, 1, 0, "geaui-icon-v2", 6);
    i0.ɵɵelementStart(4, "span", 7, 0);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, FileRowComponent_section_0_geaui_icon_v2_7_Template, 1, 2, "geaui-icon-v2", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fileNameSpan_r4 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("cursor-pointer", ctx_r1.fileId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0, ctx_r1.canDelete))("pTooltip", ctx_r1.fileName)("tooltipElement", fileNameSpan_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fileEnding !== "folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fileEnding === "folder");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.fileName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.canDelete);
  }
}
function FileRowComponent_ngx_skeleton_loader_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 12);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c1));
  }
}
export class FileRowComponent {
  fileId = '';
  index;
  fileName;
  canDelete = true;
  fileEnding;
  isLoading = false;
  removeFileByIndex = new EventEmitter();
  downloadAttachmentClicked = new EventEmitter();
  onDownloadFile() {
    if (!this.fileId) return;
    this.downloadAttachmentClicked.emit({
      fileId: this.fileId,
      fileName: this.fileName
    });
  }
  checkFileEnding(fileEnding) {
    const endingToLower = fileEnding?.toLowerCase() ?? '';
    return fileEndings.has(endingToLower) ? endingToLower : 'unknown';
  }
  static ɵfac = function FileRowComponent_Factory(t) {
    return new (t || FileRowComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FileRowComponent,
    selectors: [["geaui-file-row"]],
    inputs: {
      fileId: "fileId",
      index: "index",
      fileName: "fileName",
      canDelete: "canDelete",
      fileEnding: "fileEnding",
      isLoading: "isLoading"
    },
    outputs: {
      removeFileByIndex: "removeFileByIndex",
      downloadAttachmentClicked: "downloadAttachmentClicked"
    },
    decls: 2,
    vars: 2,
    consts: [["fileNameSpan", ""], ["class", "file-row-container", 4, "ngIf"], ["count", "1", "appearance", "line", 3, "theme", 4, "ngIf"], [1, "file-row-container"], ["geauiTooltipOnEllipsisV2", "", 3, "click", "ngClass", "pTooltip", "tooltipElement"], ["class", "file-icon", 3, "isFileIcon", "color", "file", 4, "ngIf"], ["class", "file-icon", "color", "black", "file", "16px_folder", 4, "ngIf"], [1, "gea-font-body-14", "ellipsis"], ["class", "trash-icon", 3, "color", "file", "click", 4, "ngIf"], [1, "file-icon", 3, "isFileIcon", "color", "file"], ["color", "black", "file", "16px_folder", 1, "file-icon"], [1, "trash-icon", 3, "click", "color", "file"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function FileRowComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, FileRowComponent_section_0_Template, 8, 11, "section", 1)(1, FileRowComponent_ngx_skeleton_loader_1_Template, 1, 2, "ngx-skeleton-loader", 2);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isLoading && ctx.fileName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
      }
    },
    dependencies: [i1.NgClass, i1.NgIf, i2.TooltipOnEllipsisV2Directive, i3.IconComponent, i4.NgxSkeletonLoaderComponent, i5.Tooltip],
    styles: [".file-row-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin:8px 0;width:100%;border:2px solid var(--geaui-grey-05);border-radius:4px;padding:16px}.file-row-container[_ngcontent-%COMP%]   .ellipsis[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-row-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:100%;display:flex;align-items:center}.file-row-container[_ngcontent-%COMP%]   div.with-delete-icon[_ngcontent-%COMP%]{width:90%}.file-row-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-self:center;margin-left:16px}.file-row-container[_ngcontent-%COMP%]   .trash-icon[_ngcontent-%COMP%]{cursor:pointer}skeleton-loader[_ngcontent-%COMP%]{margin:16px 0}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileRowComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-file-row',
      template: "<section class=\"file-row-container\" *ngIf=\"!isLoading && fileName\">\n  <div\n    [class.cursor-pointer]=\"fileId\"\n    [ngClass]=\"{ 'with-delete-icon ': canDelete }\"\n    [pTooltip]=\"fileName\"\n    [tooltipElement]=\"fileNameSpan\"\n    (click)=\"onDownloadFile()\"\n    geauiTooltipOnEllipsisV2>\n    <geaui-icon-v2\n      class=\"file-icon\"\n      *ngIf=\"fileEnding !== 'folder'\"\n      [isFileIcon]=\"true\"\n      [color]=\"'white'\"\n      [file]=\"'24px_' + checkFileEnding(fileEnding)\">\n    </geaui-icon-v2>\n    <geaui-icon-v2 class=\"file-icon\" *ngIf=\"fileEnding === 'folder'\" color=\"black\" file=\"16px_folder\"> </geaui-icon-v2>\n    <span class=\"gea-font-body-14 ellipsis\" #fileNameSpan>{{ fileName }}</span>\n  </div>\n  <geaui-icon-v2\n    class=\"trash-icon\"\n    *ngIf=\"canDelete\"\n    [color]=\"'black'\"\n    [file]=\"'16px_remove'\"\n    (click)=\"removeFileByIndex.emit(index)\">\n  </geaui-icon-v2>\n</section>\n<ngx-skeleton-loader *ngIf=\"isLoading\" [theme]=\"{ height: '32px', width: '100%', marginTop: '8px' }\" count=\"1\" appearance=\"line\">\n</ngx-skeleton-loader>\n",
      styles: [".file-row-container{display:flex;justify-content:space-between;align-items:center;margin:8px 0;width:100%;border:2px solid var(--geaui-grey-05);border-radius:4px;padding:16px}.file-row-container .ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-row-container div{width:100%;display:flex;align-items:center}.file-row-container div.with-delete-icon{width:90%}.file-row-container span{align-self:center;margin-left:16px}.file-row-container .trash-icon{cursor:pointer}skeleton-loader{margin:16px 0}.cursor-pointer{cursor:pointer}\n"]
    }]
  }], null, {
    fileId: [{
      type: Input
    }],
    index: [{
      type: Input
    }],
    fileName: [{
      type: Input
    }],
    canDelete: [{
      type: Input
    }],
    fileEnding: [{
      type: Input
    }],
    isLoading: [{
      type: Input
    }],
    removeFileByIndex: [{
      type: Output
    }],
    downloadAttachmentClicked: [{
      type: Output
    }]
  });
})();
